<template>
  <div class="card-form">
    <PageTable
      :loading="loading"
      :tableData="tableData"
      :tableHeight="tableHeight"
      :tablePage="page"
      :multiple="multiple"
      :reserve="reserve"
      :highlight="highlight"
      @reload="reload"
      @choose-change="(e) => $emit('choose-change', e)"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageTable>
  </div>
</template>
<script>
import PageHeader from './header.vue'
import PageTable from './table.vue'
import BaseTable from '@/mixins/base-table'
import { request } from '@/api/service'
export default {
  mixins: [BaseTable],
  components: { PageTable, PageHeader },
  props: {
    multiple: { type: Boolean, default: false },
    reserve: { type: Boolean, default: false },
    highlight: { type: Boolean, default: true },
    tableHeight: { type: Number, default: 800 },
    url: { type: String, default: '/factory/fty/material/batch/ftylist' },
    method: { type: String, default: 'POST' },
    extraData: { type: Object, default: () => {} },
  },
  data() {
    return { usePage: true }
  },
  methods: {
    getData(form) {
      if (!this.url) return

      this.loading = true
      const params = { ...form, ...this.page, ...(this.extraData || {}) }
      const method = (this.method || 'GET').toUpperCase()

      request({
        url: this.url,
        method: method,
        data: method == 'POST' ? params : null,
        params: method == 'GET' ? params : null,
      })
        .then((res) => {
          this.loading = false
          this.setData(res)
          if (!this.reserve) this.$emit('choose-change', null)
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
